(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = "0";
    });
    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };
  const slideDown = (element, duration = 300) => {
    if (!element) return;
    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;
    const height = element.scrollHeight;
    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;
    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });
    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };
  const setExpanded = (item, expanded) => {
    const button = item?.querySelector(".collapsible-content__toggle");
    if (button) button.setAttribute("aria-expanded", String(expanded));
  };
  const toggleCollapsible = (event, toggles) => {
    if (!toggles) return;
    const currentItem = event.currentTarget.closest(".collapsible-content__item");
    const answer = currentItem?.querySelector(
      ".collapsible-content__answer"
    );
    const activeItem = Array.from(toggles).find((item) =>
      item.classList.contains("active")
    );
    if (currentItem !== activeItem) {
      if (activeItem) {
        activeItem.classList.remove("active");
        setExpanded(activeItem, false);
        const activeAnswer = activeItem.querySelector(
          ".collapsible-content__answer"
        );
        if (activeAnswer) slideUp(activeAnswer);
      }
      currentItem.classList.add("active");
      setExpanded(currentItem, true);
      slideDown(answer);
    } else {
      currentItem.classList.remove("active");
      setExpanded(currentItem, false);
      slideUp(answer);
    }
  };
  const initCollapsibleContent = (section) => {
    if (!section || !section?.classList.contains("collapsible-content-section"))
      return;
    const toggles = section.querySelectorAll(".collapsible-content__item");
    toggles.forEach((toggle) =>
      toggle.querySelector(".collapsible-content__toggle")?.addEventListener("click", (event) =>
        toggleCollapsible(event, toggles)
      )
    );
  };
  const initHeadingAnimation = (section) => {
    if (
      !section ||
      !section?.classList.contains("collapsible-content-section")
    ) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener(
    "DOMContentLoaded",
    initCollapsibleContent(document.currentScript.parentElement)
  );
  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleContent(event.target);
    initHeadingAnimation(event.target);
  });
})();
